/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CriteriaFinanceReport } from '../../models/criteria-finance-report';
import { PaymentDaily } from '../../models/payment-daily';

export interface ApiReportGetCreditDebitDailyPost$Params {
      body?: CriteriaFinanceReport
}

export function apiReportGetCreditDebitDailyPost(http: HttpClient, rootUrl: string, params?: ApiReportGetCreditDebitDailyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PaymentDaily>>> {
  const rb = new RequestBuilder(rootUrl, apiReportGetCreditDebitDailyPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PaymentDaily>>;
    })
  );
}

apiReportGetCreditDebitDailyPost.PATH = '/api/Report/GetCreditDebitDaily';
